const STATIC_FILE_EXTENSIONS = /\.(?:ico|css|js|gif|jpg|jpeg|png|svg|woff2?|eot|ttf|otf)$/i;
const INTERNAL_NEXTJS_PATHS = /^\/_next\//;
const PROTECTED_PATHS = ['/dashboard'];
const SKU_PROTECTED_PATHS = ['sell', 'buy', 'fulfillBid', 'fulfillAsk'];
const PUBLIC_FILE = /\.(.*)$/;
const ADMIN_PATHS = ['/admin', '/admin/'];

const MIDDLEWARE_CONSTANTS = {
  STATIC_FILE_EXTENSIONS,
  INTERNAL_NEXTJS_PATHS,
  PROTECTED_PATHS,
  SKU_PROTECTED_PATHS,
  PUBLIC_FILE,
  ADMIN_PATHS,
};

export default MIDDLEWARE_CONSTANTS;
